import initRequests from './requests';

export default {
  initWith: initRequests,
};
